/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ImportMyFxBookDailyGainsCommand } from '../../models/import-my-fx-book-daily-gains-command';
import { SuccessApiResponse } from '../../models/success-api-response';

export interface ImportMyFxBookDailyGainsAsync$Plain$Params {
      body?: ImportMyFxBookDailyGainsCommand
}

export function importMyFxBookDailyGainsAsync$Plain(http: HttpClient, rootUrl: string, params?: ImportMyFxBookDailyGainsAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SuccessApiResponse>> {
  const rb = new RequestBuilder(rootUrl, importMyFxBookDailyGainsAsync$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SuccessApiResponse>;
    })
  );
}

importMyFxBookDailyGainsAsync$Plain.PATH = '/api/my-fx-book/daily-gains';
